import type { JSX } from 'react'

export const EditNoteIcon = (): JSX.Element => (
  <use href='#editNoteIcon' height='100%' width='100%' />
)
